import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Relative } from '../../../api/app-types/relative.app';
import { CLIENT_API } from '../../../api/injection-tokens/services.token';
import { PaginatedResponse } from '../../pagination/paginated-response';
import { NeighborContext } from '../../../api/app-types/neighbors.app';

export const relativeResolver: ResolveFn<Relative> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(CLIENT_API);
	const clientId = route.paramMap.get('id');
	const relativeId = route.paramMap.get('relativeId');
	const response = await api.getRelative(Number.parseInt(clientId!), Number.parseInt(relativeId!));
	return response;
};

export const relativesResolver: ResolveFn<PaginatedResponse<Relative>> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(CLIENT_API);
	const clientId = route.paramMap.get('id');
	const response = await api.getRelatives(Number.parseInt(clientId!));
	return response;
};

export const relativeNeighborsResolver: ResolveFn<NeighborContext<Relative>> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(CLIENT_API);
	const clientId = route.paramMap.get('id')!;
	const relativeId = route.paramMap.get('relativeId')!;
	return api.getRelativeNeighbors(clientId, relativeId);
};
